import React from "react";
import IntegerNumber from "./input-integer";
import Slct from "../Slct";
import style from "./style.module.css";

const InputTime = props => {
  const { value, valueChange, frequencyChange, placeholder = "0" } = props;
  return (
    <div className={style.input_time}>
      <button
        type="button"
        className={style.button_multiplier}
        onClick={() => {
          valueChange(value.value * -1);
        }}
      >
        <span data-on={value.value > 0 ? true : false}>+</span>
        <span data-on={value.value < 0 ? true : false}>-</span>
      </button>
      <IntegerNumber
        value={value.value}
        valueChange={ev => {
          valueChange(ev);
        }}
        className={style.number}
        placeholder={placeholder}
      />
      <Slct
        options={[
          { label: "Dias", value: "daily" },
          { label: "Meses", value: "monthly" },
        ]}
        value={value.frequency}
        onChange={ev => {
          frequencyChange(ev.value);
        }}
        className={`${style.select}`}
        placeholder="..."
      />
    </div>
  );
};

export default InputTime;
